import { setDisplayErrorSnackBar } from "../../../../features/userSlice";
import { optifundDashboardService } from "../../../../services/api/optifund-dashboard.endpoints";
import store from "../../../../store";

// Returns whether the query actually succeeded (setData was called) - callers
// that need to distinguish "loading" from "failed" (see useOptifundTabData's
// setError param) rely on this instead of just the loading flag, since a
// failed call must stop looking like it's still loading.
async function runQuery(
  oauthTokenHeader: string,
  queryId: string,
  websiteSharedUid: string,
  setData: any,
  startDate?: string,
  endDate?: string,
  brand?: string,
  month?: number,
  year?: number,
): Promise<boolean> {
  try {
    if (!websiteSharedUid) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Missing website_shared_uid - cannot run this query.",
          type: "error",
        }),
      );
      return false;
    }

    const response = await optifundDashboardService.runOptifundBizLayerQuery(
      oauthTokenHeader,
      queryId,
      websiteSharedUid,
      startDate,
      endDate,
      brand,
      month,
      year,
    );
    if (!response || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong...",
          type: "error",
        }),
      );
      return false;
    }

    const rows = response?.data?.data?.query_output;
    if (!Array.isArray(rows)) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Unexpected response format from the query.",
          type: "error",
        }),
      );
      return false;
    }

    setData(rows);
    return true;
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
    return false;
  }
}

export const OptifundDashboardEndPointLogic = { runQuery };
